<template>
  <div class="popup">

    <v-container class="component-container">
      <v-row v-if="popup.einleitung_text">
        <v-col cols="12">
          <MediaSwiperV2 :content="popup.galerie_files" contentWidth="876"/>
        </v-col>
        <v-col cols="12" class="wysiwyg">
          <div v-html="popup.einleitung_text" />
        </v-col>
      </v-row>
    </v-container>
    
    <v-container class="component-container-purple" >
      <v-container class="component-container pa-0" style="margin: 0px auto 0px auto">
        <v-row>
          <v-col cols="12">
            <span class="text-big">Aktuelle Ausstellungen und Veranstaltungen</span>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container class="component-container">
      <v-row v-if="popup.mitte_text" class="text">
        <v-col cols="12" class="wysiwyg">
          <div v-html="popup.mitte_text" />
        </v-col>
      </v-row>
    </v-container>

    <v-container class="component-container-purple" >
      <v-container class="component-container pa-0" style="margin: 0px auto 0px auto">
        <v-row>
          <v-col cols="12">
            <span class="text-big">Verein zur Förderung von Kunst und Stadtteilkultur im NAA</span>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container class="component-container">
      <v-row v-if="popup.ende_text" class="text">
        <v-col cols="12" class="wysiwyg">
          <div v-html="popup.ende_text" />
        </v-col>
      </v-row>
    </v-container>
    
  </div>
</template>

<script>

export default {
  name: 'PopupV2',
  data: () => ({
    popup: {}
  }),
  async created() {
    let temp = await this.$client.items("popup").readMany({ fields: ['*.*.*'] })

    this.popup = temp.data
  }
}
</script>

<style lang="scss">

  @import "@/assets/_variables.scss";

  .text {
    background-color: $beige !important;
    color: black;

    .headline {
      background-color: $purple !important;
      color: $beige;
      font-size: $font-size-1-normal !important;

      p {
        margin: 0
      }
    }

    ul {
      
      margin-left: 30px;
      
      li {
        list-style-type: "-";
        padding-left: 10px;
      }

      li::marker {
        color: $purple;
        font-size: $font-size-1-normal;
      }
    }
  }
    
  .text-big-bold {
    font-size: $font-size-2-normal; 
    font-weight:bold
  }


</style>